import { VERSION_LABEL } from '~/modules/report-analytic/constants';
import { IVariantType } from '~/modules/campaign/types';

export const CHART_COLORS = [
  '#13acf0',
  '#6A42E9',
  '#597eed',
  '#d147ac',
  '#23baba',
  '#9b3cdd',
  '#9e84f2',
  '#128ac0',
  '#d75eb7',
];
export const SINGLE_CHART_COLOR = '#4FA9EA';
export const COMPARISON_CHART_COLOR = '#A1CAE7';
export const NONE_VALUE = 'None';

export const CHART_COLOR_MAP = {
  [VERSION_LABEL[IVariantType.VARIANT_A]]: '#2C7DFF',
  [VERSION_LABEL[IVariantType.VARIANT_B]]: '#F34A70',
  [NONE_VALUE]: CHART_COLORS[CHART_COLORS.length - 1],
};
